<template>
  <div class="confirmation">
    <app-title title="Order"/>

    <div class="row">
      <div class="col-md-3 p-md-3 text-center">
        <img class="header-logo" src="/images/logo.png">
      </div>
      <div class="col-md-7 content-middle dashboard-row p-md-3 mt-md-3">
        <router-link class="link" to="/dashboard">
          <font-awesome-icon class="font-awesome-icon" icon="arrow-circle-left"/>
          Dashboard
        </router-link>
      </div>
      <div class="col-md-3 sidebar-account p-md-3">
        <div class="row account-row ">
          <app-account/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle main p-md-3"></div>
      <div class="col-md-3 d-none d-sm-block"></div>
    </div>

    <div class="row">
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
      <div class="col-md-7 content-middle p-md-3">
        <div class="sub-title">
          Bedankt voor je bestelling
        </div>

        <div class="card card-body mt-3">
          <div class="card-order-details">
            <div class="row order-details">
              <div class="col-md-13">
                Order #{{ confirmationDetails.orderId }}
                <span class="float-right text-right">
                  In bestelling
                </span>
              </div>
            </div>

            <div class="row date-details">
              <div class="col-md-13">
                Besteldatum: {{ confirmationDetails.orderDate }}
                <span class="float-right text-right">
                  Leverdatum: {{ confirmationDetails.deliveryDate }}
                </span>
              </div>
            </div>

            <hr/>

            <div class="row">
              <div class="col-md-13">
                <p>Ter bevestiging heb je een e-mail ontvangen op {{ confirmationDetails.email }}.</p>

                <p>Je order is terug te vinden op
                  <router-link class="router-link" to="/dashboard">je dashboard</router-link>
                  onder het orderoverzicht.
                </p>

                <p>
                  Let op:
                  <ul>
                    <li>Wijzigingen in de maatvoering en materiaal zijn niet meer mogelijk</li>
                    <li>Leveringen vinden op werkdagen plaats tussen 08:00 en 17:00</li>
                    <li>Wijzigingen in levering (adres, dag) kunnen uiterlijk 48-uur van te voren per mail doorgegeven worden ovv:<br>"Wijziging levering #{{ confirmationDetails.orderId }}"</li>
                  </ul>
                </p>


              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-3 p-md-3 d-none d-sm-block"></div>
    </div>
  </div>
</template>

<script>
  import Account from '@/components/Account/Account.vue'

  export default {
    name: 'confirmation',
    data() {
      return {}
    },
    components: {
      'app-account': Account
    },
    computed: {
      confirmationDetails() {
        return this.$store.getters.confirmationDetails
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-order-details {
    margin-left: 25px;
    margin-right: 25px;
  }

  .order-details {
    font-weight: bold;
  }

  .date-details {
    color: $light-grey;
  }

  .router-link {
    text-decoration: underline;
  }
</style>
